import { FC, useState } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { PaginationController } from '../../../../components/pagination-controller/index';
import { EventHooks, useFormat } from '../../../../hooks/index';
import {
  eventFormType,
  EventTypeBackend,
  SecondariesEventItem,
} from '../../../../types/events.types';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Secondaries: FC<CardProps> = ({ event, companyId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { format } = useFormat();
  const { items, totalPages } = EventHooks.useTransactions<SecondariesEventItem>({
    eventId: event.id,
    eventType: EventTypeBackend.SECONDARIES,
    companyId: companyId,
    currentPage,
  });
  if (event.type !== EventTypeBackend.SECONDARIES) return <></>;

  const { type } = event;

  return (
    <>
      {items.map(
        ({ sharesCount, shareClass, date, fromStakeholder, sharesValue, toStakeholder }, i) => (
          <div
            className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm"
            key={i + shareClass.id}
          >
            <TransactionTitleItem
              createdAt={format(date, 'dd/MM/yyyy')}
              name={<AppFormattedMessage id={eventFormType[type]} />}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
              value={<AppFormattedMessage id={eventFormType[type]} />}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="FROM_STAKEHOLDER" />}
              value={fromStakeholder.fullName}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="TO_STAKEHOLDER" />}
              value={toStakeholder.fullName}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="SHARE_CLASS" />}
              value={shareClass.name}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="NO_OF_SHARES" />}
              value={sharesCount.toLocaleString('en-US')}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="SHARE_VALUE" />}
              value={sharesValue.toLocaleString('en-US')}
            />
            <TransactionOverviewItem
              title={<AppFormattedMessage id="TRANSFER_AMOUNT" />}
              value={(sharesCount * sharesValue).toLocaleString('en-US')}
            />
          </div>
        ),
      )}
      <PaginationController
        className="mt-6 shrink-0"
        currentPage={currentPage}
        onClick={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  );
};
